import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { MaskLines, Reveal } from "@/components/site/Motion";
import { waLink } from "@/lib/content";
import { LeafCutout } from "./Decor";

export function CtaBand({ testId = "cta-band", title = ["Ready to start", "your transformation?"] }: { testId?: string; title?: string[] }) {
  return (
    <section data-testid={testId} className="relative bg-forest-deep py-16 sm:py-24">
      <div className="wrap">
        <div className="grain relative grid overflow-hidden rounded-[32px] bg-forest ring-1 ring-cream/10 lg:grid-cols-12">
          <div className="relative h-56 lg:col-span-4 lg:h-auto">
            <img src="/images/smoothie.jpg" alt="Fresh green smoothie in a glass" loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-forest/80 to-transparent lg:bg-gradient-to-l" />
          </div>
          <div className="relative p-8 sm:p-12 lg:col-span-8">
            <LeafCutout variant="b" className="-bottom-10 -right-10 h-40 w-64 opacity-80" speed={0.05} />
            <h2 className="relative text-4xl leading-[1.02] text-cream sm:text-6xl">
              <MaskLines lines={[title[0], <em key="t" className="text-gold-soft">{title[1]}</em>]} />
            </h2>
            <Reveal delay={0.15}>
              <p className="relative mt-5 max-w-md text-base text-cream/85">Book your free 20-minute consultation today. No obligation, no payment.</p>
              <div className="relative mt-8 flex flex-col gap-3 sm:flex-row">
                <Link to="/contact#book" className="btn-gold group" data-testid={`${testId}-book`}>Book Free Consultation <ArrowRight className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-1" /></Link>
                <a href={waLink()} target="_blank" rel="noreferrer" className="btn-cream" data-testid={`${testId}-whatsapp`}><MessageCircle className="h-4 w-4" /> WhatsApp Sony</a>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
